define('templates/deleted-device-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            'pac' : templateBuilder.basicHeader('pac', 'PAC'),
            'deletedBy' : templateBuilder.basicHeader('deletedBy', 'Deleted by'),
            'name' : templateBuilder.basicHeader('name', 'Name'),
            
            // Sortable headers
            'id' : templateBuilder.basicHeader('id', 'Id'),
            'deletionDate' : templateBuilder.sortableHeader('deletionDate', 'Deletion date', 'creationTime')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'id' : templateBuilder.basicNode('${id}'),
            'deletionDate' : templateBuilder.basicNode('${deletionDate}'),
            'deletedBy' : templateBuilder.linkNode('${deletedByUrl}', '${deletedBy}'),
            'name' : templateBuilder.basicNode('${name}'),
            'pac' : templateBuilder.basicNode('${pac}')
        } // end templates data
    }; // end return
});

